import { usePrivateMutation as useMutation } from "@/lib/query/core/use-private-mutation";
import { useQueryClient } from "@tanstack/react-query";
import type { StorePremiumView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminStoreSubscriptions } from "@/lib/query/core/invalidation";

type SetStorePremiumInput = {
  storeId: string;
  isPremium: boolean;
  expectedRevision?: number;
};

export function useSetStorePremiumMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({
      storeId,
      isPremium,
      expectedRevision,
    }: SetStorePremiumInput) =>
      apiJsonClient<StorePremiumView>(endpoints.admin.storePremium(storeId), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ isPremium, expectedRevision }),
      }),
    onSettled: async (_data, _error, variables) => {
      await invalidateAdminStoreSubscriptions(queryClient, variables.storeId);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
